<template>
	<section>
		<h4 class="card-subtitle">Featured Image</h4>
		<label v-if="!image" class="file-upload" for="image-featured">
			<input id="image-featured" type="file" ref="file" name="image-featured" @change="handleFileUpload()">
			<span><i class="fas fa-upload"></i>&nbsp; Upload your file here.</span>
		</label>
		<div v-else>
			<img :src="image">
			<div class="text-center mt-1">
				<input id="change-image-featured" class="hidden" type="file" ref="fileChange" name="image-featured" @change="handleFileUpload()">
				<button class="btn btn-sm btn-primary" :disabled="inProgress" @click="$refs.fileChange.click()">Change</button>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		props: {
			dataArticleId: {
				type: Number
			},
			dataImage: {
				type: String,
				required: false
			},
		},
		data() {
			return {
				articleId: this.dataArticleId,
				image: this.dataImage ? this.dataImage : null,
				file: '',
				inProgress: false
			}
		},
		methods: {
			handleFileUpload: function () {
				this.inProgress = true;
				if (this.image) {
					this.file = this.$refs.fileChange.files[0];
				} else {
					this.file = this.$refs.file.files[0];
				}

				if (this.file) {

					let reader = new FileReader();

					reader.onload = (e) => {
						this.image = e.target.result;

						let formData = new FormData();

						formData.append('file', this.file);

						axios.post('/api/' + this.$selectedSite.slug + '/articles/' + this.articleId + '/upload/featuredImage',
							formData,
							{
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							}
						).then(function (response) {
							if (response.data.success) {
								this.$toastr.success('Featured image uploaded successful.', 'Success');
							} else {
								this.$toastr.error('Featured image uploaded failed.', 'Error');
							}
							this.inProgress = false;
						}).catch(function () {
							this.$toastr.error('Featured image uploaded failed.', 'Error');
						});
					};
					reader.readAsDataURL(this.file);
				}
			}
		}
	}
</script>

<style scoped>

</style>
